import React, { useState, useEffect } from 'react';
import 'react-image-crop/dist/ReactCrop.css';
import './index.css'; // Importation des styles globaux

// Firebase
import { auth, onAuthStateChanged, signOut } from './firebase/config';

// Vues principales
import AuthScreen from './components/auth/AuthScreen';
import Dashboard from './components/dashboard/Dashboard';
import SeminarEditor from './components/editor/SeminarEditor';
import RegistrationPage from './components/blog/RegistrationPage';

export default function App() {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [currentView, setCurrentView] = useState({ view: 'dashboard', seminarId: null });
    const [seminars, setSeminars] = useState([]);
    const [editingSeminar, setEditingSeminar] = useState(null);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
            setUser(currentUser);
            setLoading(false);
        });
        return () => unsubscribe();
    }, []);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const view = params.get('view');
        const seminarId = params.get('seminarId');
        if (view === 'register' && seminarId) {
            setCurrentView({ view: 'register', seminarId: seminarId });
        }
    }, []);

    // ... (Coller ici les données de séminaire de démo de votre useEffect) ...
    useEffect(() => {
     const initialGroups = [
         { id: 'group-1', name: 'VIP', color: '#FFD700' },
         { id: 'group-2', name: 'Staff', color: '#4A90E2' }
     ];
     const defaultBlogTitleStyle = {
         fontSize: 24,
         fontWeight: 'bold',
         textAlign: 'left',
         fontFamily: 'Lato',
         color: '#000000',
         backgroundColor: '#FFFFFF',
         paddingTop: 16,
         paddingBottom: 16,
     };
     setSeminars([
         { id: `seminar-${Date.now()}-1`, name: "Sommet de l'Innovation Tech", location: "Paris, France", startDate: "2025-10-15", endDate: "2025-10-17", isMultiDay: true, isPublished: true, isLocked: true, creatorId: "fake-user-id-123", logoUrl: 'https://placehold.co/100x100/22D6B5/ffffff?text=Logo1', guests: [{email: 'test@example.com', status: 'inscrit', groupId: 'group-1', fonction: 'CEO'}, {email: 'invite@example.com', status: 'en attente', groupId: 'group-2', fonction: 'Développeur'}, {email: 'new@example.com', status: 'non envoyé', groupId: '', fonction: ''}, {email: 'declined@example.com', status: 'refus', groupId: '', fonction: 'Designer'}], visibility: 'privé', password: 'tech2025', design: [], groups: initialGroups, hasBlog: true, blogName: 'L\'album du Sommet', blogPhotos: [], blogTitleStyle: defaultBlogTitleStyle, seminarUrl: 'https://myseminar.fr/sommet-de-linnovation-tech' },
         { id: `seminar-${Date.now()}-2`, name: "Rencontre Annuelle Marketing", location: "Lyon, France", startDate: "2025-11-20", isPublished: false, isLocked: false, creatorId: "fake-user-id-123", logoUrl: '', guests: [], visibility: 'public', password: '', design: [], groups: [], hasBlog: false, blogName: '', blogPhotos: [], blogTitleStyle: defaultBlogTitleStyle, seminarUrl: '' },
         { id: `seminar-${Date.now()}-3`, name: "Séminaire d'un autre utilisateur", location: "Lille, France", startDate: "2025-09-15", isPublished: true, isLocked: true, creatorId: "other-user-id-456", logoUrl: '', guests: [], visibility: 'privé', password: '', design: [], groups: [], hasBlog: false, blogName: '', blogPhotos: [], blogTitleStyle: defaultBlogTitleStyle, seminarUrl: 'https://myseminar.fr/seminaire-dun-autre-utilisateur' },
     ]);
    }, []);

    const handleGoToEditor = (seminarId) => {
        if (seminarId === null) {
            const newSeminar = {
                id: `seminar-${Date.now()}`,
                name: '',
                location: '',
                startDate: '',
                endDate: '',
                isMultiDay: false,
                isPublished: false,
                isLocked: false,
                creatorId: user.uid,
                logoUrl: '',
                guests: [],
                visibility: 'privé',
                password: '',
                design: [],
                groups: [],
                hasBlog: false,
                blogName: '',
                blogPhotos: [],
                seminarUrl: '',
                blogTitleStyle: {
                    fontSize: 24, fontWeight: 'bold', textAlign: 'left', fontFamily: 'Lato',
                    color: '#000000', backgroundColor: '#FFFFFF', paddingTop: 16, paddingBottom: 16,
                }
            };
            setEditingSeminar(newSeminar);
        } else {
            const seminarToEdit = seminars.find(s => s.id === seminarId);
            setEditingSeminar({ ...seminarToEdit });
        }
        setCurrentView({ view: 'editor', seminarId: seminarId });
    };

    const handleBackToDashboard = () => {
        setEditingSeminar(null);
        setCurrentView({ view: 'dashboard', seminarId: null });
    };
    
    // ... Collez ici le reste de vos fonctions handlers ...
    // handleSaveSeminar, handleDeleteSeminar, handlePublishSeminar, handleUnpublishSeminar, 
    // handleUpdateGuest, handleSignOut
    const handleSaveSeminar = (seminarData) => {
        setSeminars(currentSeminars => {
            const exists = currentSeminars.some(s => s.id === seminarData.id);
            if (exists) {
                return currentSeminars.map(s => s.id === seminarData.id ? seminarData : s);
            }
            return [seminarData, ...currentSeminars];
        });
        setEditingSeminar(seminarData);
    };

    const handleDeleteSeminar = (seminarIdToDelete) => setSeminars(cs => cs.filter(s => s.id !== seminarIdToDelete));
    
    const handlePublishSeminar = (seminarIdToPublish) => {
        const seminarToPublish = seminars.find(s => s.id === seminarIdToPublish);
        if (!seminarToPublish) return;

        const slugify = (text) => text.toString().toLowerCase()
            .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
            .replace(/\s+/g, '-').replace(/[^\w-]+/g, '')
            .replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');

        let baseSlug = slugify(seminarToPublish.name || 'seminaire-sans-nom');
        let finalSlug = baseSlug;
        let counter = 1;

        while (seminars.some(s => s.seminarUrl && s.seminarUrl.endsWith(`/${finalSlug}`) && s.id !== seminarIdToPublish)) {
            finalSlug = `${baseSlug}-${counter}`;
            counter++;
        }

        const finalUrl = `https://myseminar.fr/${finalSlug}`;
        const updatedSeminars = cs => cs.map(s => s.id === seminarIdToPublish ? { ...s, isPublished: true, isLocked: true, seminarUrl: finalUrl } : s);
        setSeminars(updatedSeminars);
        
        if (editingSeminar && editingSeminar.id === seminarIdToPublish) {
            setEditingSeminar(prev => ({ ...prev, isPublished: true, isLocked: true, seminarUrl: finalUrl }));
        }
        alert(`Séminaire publié ! \nVotre lien est : ${finalUrl}`);
    };

    const handleUnpublishSeminar = (seminarIdToUnpublish) => {
        const updatedSeminars = cs => cs.map(s => s.id === seminarIdToUnpublish ? { ...s, isPublished: false, seminarUrl: '' } : s);
        setSeminars(updatedSeminars);

        if (editingSeminar && editingSeminar.id === seminarIdToUnpublish) {
            setEditingSeminar(prev => ({ ...prev, isPublished: false, seminarUrl: '' }));
        }
        alert('Séminaire mis hors ligne.');
    };
    
    const handleUpdateGuest = (seminarId, guestEmail, newStatus, details) => {
        setSeminars(prevSeminars => {
            return prevSeminars.map(seminar => {
                if (seminar.id === seminarId) {
                    const updatedGuests = seminar.guests.map(guest => {
                        if (guest.email.toLowerCase() === guestEmail.toLowerCase()) {
                            return { ...guest, ...details, status: newStatus };
                        }
                        return guest;
                    });
                    return { ...seminar, guests: updatedGuests };
                }
                return seminar;
            });
        });
    };
    
    const handleSignOut = async () => {
        try {
            await signOut(auth);
        } catch (error) {
            console.error("Error signing out: ", error);
        }
    };


    const renderCurrentView = () => {
        if (loading) {
            return <div className="flex justify-center items-center h-screen">Chargement...</div>;
        }

        if (currentView.view === 'register') {
            const seminarForRegistration = seminars.find(s => s.id === currentView.seminarId);
            return <RegistrationPage seminar={seminarForRegistration} onUpdateGuest={handleUpdateGuest} />;
        }

        if (!user) {
            return <AuthScreen />;
        }

        switch (currentView.view) {
            case 'editor':
                return editingSeminar && <SeminarEditor user={user} seminar={editingSeminar} onSave={handleSaveSeminar} onPublish={handlePublishSeminar} onUnpublish={handleUnpublishSeminar} onBackToDashboard={handleBackToDashboard} onSignOut={handleSignOut} />;
            case 'dashboard':
            default:
                return <Dashboard user={user} seminars={seminars} onGoToEditor={handleGoToEditor} onDeleteSeminar={handleDeleteSeminar} onSignOut={handleSignOut} />;
        }
    };

    return renderCurrentView();
}